// src/firebase/config.js
// ADD getStorage export — needed for announcement attachments
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  memoryLocalCache,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDRofsqBNhvRjMDegkR-wNa5O30wFLk5Mc",
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "samriddhi-dev-b2c0b.firebaseapp.com",
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID || "samriddhi-dev-b2c0b",
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "samriddhi-dev-b2c0b.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "156402993828",
  appId:             process.env.REACT_APP_FIREBASE_APP_ID || "1:156402993828:web:3dafd88697d62191943431",
};

const app = initializeApp(firebaseConfig);

export const auth    = getAuth(app);
export const storage = getStorage(app);   // ← NEW

export const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});

export default app;